export const DEFAULT_ERROR_MESSAGE =
  'Oops. Something went wrong, please try again. :(';
